import styled, { FlattenInterpolation, ThemeProps } from 'styled-components';
import {
  useModelForm, FormInput, ThemeType, SearchSelectBox,
} from '../../../../..';

export type ModelSelectSearchInputPropsType = {
  options?: { [key: string]: string },
  field: string,
  label?: string,
  labelStyles?: string,
  disabled?: boolean,
  valueOverride?: string,
  errorOverride?: string,
  placeholder?: string,
  mutateValue?: (newValue: string) => any,
  required?: boolean,
  containerCss?: FlattenInterpolation<ThemeProps<ThemeType>> | string,
  onBlur?: (targetValue?: string) => void,
  touchOverride?: boolean,
  isTooltipError?: boolean,
  isTable?: boolean,
}

const TableFixWrapper = styled.div<{isTable: boolean}>`${({ isTable }) => `
  ${isTable ? 'position: relative !important;' : ''}
`}`;

export function ModelSelectSearchInput({
  options = {},
  field,
  label = '',
  labelStyles = '',
  disabled = false,
  valueOverride,
  errorOverride = '',
  mutateValue = (newValue) => newValue,
  placeholder = undefined,
  required = false,
  containerCss,
  onBlur = () => {},
  touchOverride = false,
  isTooltipError = false,
  isTable = false,
}: ModelSelectSearchInputPropsType) {
  const {
    errors, update, value, warnings,
  } = useModelForm(field, valueOverride, errorOverride);

  const optionsArray = Object.entries(options).sort((a, b) => {
    if (a[1] < b[1]) { return -1; }
    if (a[1] > b[1]) { return 1; }
    return 0;
  });

  const onChangeItem = async (v: string) => {
    update({ [field]: mutateValue(v) });
  };

  const filteredOptions = optionsArray.reduce((prev, [optionKey, optionValue]) => ({
    ...prev,
    [optionKey]: optionValue,
  }), {});

  return (
    <FormInput css={containerCss}>
      <TableFixWrapper isTable={isTable}>
        <SearchSelectBox
          id={field}
          value={value}
          errors={errors}
          warnings={warnings}
          searchPlaceholder={placeholder}
          label={label}
          labelStyles={labelStyles}
          options={filteredOptions}
          onChangeItem={onChangeItem}
          disabled={disabled}
          required={required}
          onBlur={onBlur}
          touchOverride={touchOverride}
          isTooltipError={isTooltipError}
        />
      </TableFixWrapper>
    </FormInput>
  );
}
